import { PDFHeader } from "../../../../../global/globalFunctions";
import API from "../../../../../global/api";
import jsPDF from "jspdf";
import _ from "lodash";
import "jspdf-autotable";
import moment from "moment";


export const requestAddInvoice = () => {
    return {
        type: "REQUEST_ADD_INVOICE",
    };
};
export const successAddInvoice = (data) => {
    return {
        type: "SUCCESS_ADD_INVOICE",
        payload: data,
    };
};
export const errorAddInvoice = () => {
    return {
        type: "ERROR_ADD_INVOICE",
    };
};
export const AddInvoiceApi = (data, showSuccessAlert, showErrorAlert) => {
    return (dispatch) => {
        dispatch(requestAddInvoice());
        API.post(`/invoice/add-invoice`, data).then((res) => {
            dispatch(successAddInvoice(data));
            showSuccessAlert(res.data.message);
        }).catch((error) => {
            dispatch(errorAddInvoice());
            showErrorAlert(error.response.data.message || "Something went wrong");
        })
    };
};


export const requestGetInvoice = () => {
    return {
        type: "REQUEST_GET_INVOICE",
    };
};
export const successGetInvoice = (data) => {
    return {
        type: "SUCCESS_GET_INVOICE",
        payload: data,
    };
};
export const errorGetInvoice = () => {
    return {
        type: "ERROR_GET_INVOICE",
    };
};
export const GetInvoiceApi = () => {
    return (dispatch) => {
        dispatch(requestGetInvoice());
        API.get(`/invoice/get-invoice`).then((res) => {
            let getData = res.data;
            dispatch(successGetInvoice(getData));
        }).catch((error) => {
            dispatch(errorGetInvoice());
        })
    };
};


export const requestDeleteInvoice = () => {
    return {
        type: "REQUEST_DELETE_MACHINE",
    };
};
export const successDeleteInvoice = (user_id) => {
    return {
        type: "SUCCESS_DELETE_MACHINE",
        user_id: user_id,
    };
};
export const errorDeleteInvoice = () => {
    return {
        type: "ERROR_DELETE_MACHINE",
    };
};
export const DeleteInvoiceApi = (id) => {
    return dispatch => {
        dispatch(requestDeleteInvoice());
        API.delete(`/invoice/delete-invoice/${id}`).then(res => {
            dispatch(successDeleteInvoice(id))
        }).catch((error) => {
            dispatch(errorDeleteInvoice())
        });
    }
};


export const PrintInvoicePDF = (data) => {
    return (dispatch) => {
        const unit = "pt";
        const size = "A4";
        const orientation = "potrait";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Invoice Report");

        const sequenceNumber = "Invoice No: " + data.sequenceNumber;
        const invoiceDate = "Invoice Date: " + moment(data?.invoiceDate).format('DD-MM-YYYY');
        const customer = "Customer: " + data.customerDetails?.customerName;
        const manualInvoiceNo = "Manual Invoice Number: " + data.manualInvoiceNumber;
        const createdBy = "Created By: " + data.userDetails.userName;
        const remarks = "Remarks: " + data.remarks;
        const invoiceTotal = "Invoice Total: " + data.invoiceTotal;

        const headers = [[
            "S.No",
            "Item",
            "Sale Price",
            "Quantity",
            "Total Price",
        ]];
        const prodactData = _.isEmpty(data.data) ? '' : data.data.map((elt, i) => [
            i + 1,
            elt.item,
            elt.salePrice,
            elt.quantity,
            elt.totalPrice,
        ]);
        if (!_.isEmpty(prodactData)) {
            prodactData.push([
                "",
                { content: "TOTAL", colSpan: 1, styles: { halign: "left", fontStyle: "bold" } },
                { content: parseFloat(_.sumBy(prodactData, '2').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
                { content: parseFloat(_.sumBy(prodactData, '3').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
                { content: parseFloat(_.sumBy(prodactData, '4').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
            ])
        }
        let ProductContent = {
            startY: 190,
            startX: 50,
            head: headers,
            styles: { fontSize: 9 },
            body: prodactData,
            theme: "grid",
            headStyles: { fillColor: "#2980ba" },
        };
        doc.autoTable(ProductContent);

        doc.setFontSize(12);
        doc.setFont("Times New Roman", "normal")
        doc.text(sequenceNumber, 50, 130, 0, 20);
        doc.text(invoiceDate, 330, 130, 0, 20);
        doc.text(customer, 50, 145, 0, 20);
        doc.text(manualInvoiceNo, 330, 145, 0, 20);
        doc.text(remarks, 50, 160, 0, 20);
        doc.text(createdBy, 50, 175, 0, 20);
        doc.setFont("Times New Roman", "bold");
        doc.text(invoiceTotal, 400, doc.lastAutoTable.finalY + 20, 0, 20);

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // --- English note ---
        const englishNote = "Note: Before returning the goods, please check your goods thoroughly and confirm that all items are complete. The company will not be responsible for any shortages or losses later.";
        const englishNoteWidth = pageWidth - 60;
        doc.setFontSize(14);
        doc.setFont("Times New Roman", "normal");
        doc.setTextColor(0, 0, 0);
        const englishNoteLines = doc.splitTextToSize(englishNote, englishNoteWidth);
        const englishLineHeight = 13;
        const englishNoteY = doc.lastAutoTable.finalY + 60;
        doc.text(englishNoteLines, pageWidth / 2, englishNoteY, { align: "center" });
        const englishNoteHeight = englishNoteLines.length * englishLineHeight;

        // --- Urdu note rendered via canvas (RTL shaping by browser) ---
        const urduNote = "نوٹ : واپسی پر مال لے جانے سے پہلے براہِ کرم اپنا مال اچھی طرح چیک کر لیں اور تصدیق کر لیں کہ تمام سامان مکمل ہے۔ بعد ازاں کسی کمی یا نقصان کی صورت میں کمپنی ذمہ دار نہیں ہوگی۔";
        const canvasWidth = 1600;
        const urduFontSize = 40;
        const urduLineHeight = 50;

        const measureCanvas = document.createElement('canvas');
        measureCanvas.width = canvasWidth;
        measureCanvas.height = 40;
        const mCtx = measureCanvas.getContext('2d');
        mCtx.font = `${urduFontSize}px Arial, "Noto Nastaliq Urdu", "Jameel Noori Nastaleeq"`;
        const urduWords = urduNote.split(' ');
        const urduLines = [];
        let currentLine = '';
        urduWords.forEach(word => {
            const testLine = currentLine ? `${currentLine} ${word}` : word;
            if (mCtx.measureText(testLine).width > canvasWidth - 40 && currentLine) {
                urduLines.push(currentLine);
                currentLine = word;
            } else {
                currentLine = testLine;
            }
        });
        if (currentLine) urduLines.push(currentLine);

        const noteCanvas = document.createElement('canvas');
        noteCanvas.width = canvasWidth;
        noteCanvas.height = urduLines.length * urduLineHeight + 20;
        const nCtx = noteCanvas.getContext('2d');
        nCtx.fillStyle = '#ffffff';
        nCtx.fillRect(0, 0, noteCanvas.width, noteCanvas.height);
        nCtx.font = `${urduFontSize}px Arial, "Noto Nastaliq Urdu", "Jameel Noori Nastaleeq"`;
        nCtx.direction = 'rtl';
        nCtx.textAlign = 'center';
        nCtx.fillStyle = '#000000';
        urduLines.forEach((line, i) => {
            nCtx.fillText(line, canvasWidth / 2, urduLineHeight * (i + 1));
        });

        const noteImgWidth = pageWidth - 60;
        const noteImgHeight = (noteCanvas.height / noteCanvas.width) * noteImgWidth;
        const noteY = englishNoteY + englishNoteHeight + 15;
        doc.addImage(noteCanvas.toDataURL('image/png'), 'PNG', 30, noteY, noteImgWidth, noteImgHeight);

        // --- "No Credit" notice (ادھار بند ہے), rendered via canvas, last line ---
        const noCreditNote = "ادھار بند ہے";
        const noCreditCanvasWidth = 800;
        const noCreditFontSize = 80;

        const noCreditCanvas = document.createElement('canvas');
        noCreditCanvas.width = noCreditCanvasWidth;
        noCreditCanvas.height = 70;
        const ncCtx = noCreditCanvas.getContext('2d');
        ncCtx.fillStyle = '#ffffff';
        ncCtx.fillRect(0, 0, noCreditCanvas.width, noCreditCanvas.height);
        ncCtx.font = `bold ${noCreditFontSize}px Arial, "Noto Nastaliq Urdu", "Jameel Noori Nastaleeq"`;
        ncCtx.direction = 'rtl';
        ncCtx.textAlign = 'center';
        ncCtx.fillStyle = '#cc0000';
        ncCtx.fillText(noCreditNote, noCreditCanvas.width / 2, 50);

        const noCreditImgWidth = 140;
        const noCreditImgHeight = (noCreditCanvas.height / noCreditCanvas.width) * noCreditImgWidth;
        const noCreditY = noteY + noteImgHeight + 15;
        doc.addImage(
            noCreditCanvas.toDataURL('image/png'),
            'PNG',
            (pageWidth - noCreditImgWidth) / 2,
            noCreditY,
            noCreditImgWidth,
            noCreditImgHeight
        );

        // --- Fixed footer: coloured bank details panel ---
        const footerHeight = 80;
        const footerY = pageHeight - footerHeight;
        const mid = pageWidth / 2;

        // Light blue background for the whole footer
        doc.setFillColor(235, 245, 255);
        doc.roundedRect(20, footerY, pageWidth - 40, footerHeight - 10, 4, 4, 'F');

        // Accent top border line
        doc.setDrawColor(41, 128, 186);
        doc.setLineWidth(1.5);
        doc.line(20, footerY, pageWidth - 20, footerY);

        // Left card: Bank Alfalah (light green tint)
        doc.setFillColor(220, 240, 255);
        doc.roundedRect(28, footerY + 8, mid - 36, footerHeight - 24, 3, 3, 'F');

        doc.setFontSize(11);
        doc.setFont("Times New Roman", "bold");
        doc.setTextColor(41, 128, 186);
        doc.text("Bank Alfalah", mid / 2, footerY + 24, { align: "center" });

        doc.setFontSize(9);
        doc.setFont("Times New Roman", "normal");
        doc.setTextColor(50, 50, 50);
        doc.text("PK52ALFH0764001010263325", mid / 2, footerY + 38, { align: "center" });
        doc.text("WARRAICH WASHING COMPANY", mid / 2, footerY + 51, { align: "center" });

        // Right card: JazzCash (light red tint)
        doc.setFillColor(255, 240, 220);
        doc.roundedRect(mid + 8, footerY + 8, mid - 36, footerHeight - 24, 3, 3, 'F');

        doc.setFontSize(11);
        doc.setFont("Times New Roman", "bold");
        doc.setTextColor(210, 100, 20);
        doc.text("JazzCash", mid + 8 + (mid - 36) / 2, footerY + 24, { align: "center" });

        doc.setFontSize(9);
        doc.setFont("Times New Roman", "normal");
        doc.setTextColor(50, 50, 50);
        doc.text("03033056169", mid + 8 + (mid - 36) / 2, footerY + 38, { align: "center" });
        doc.text("Sarmad Maqsood", mid + 8 + (mid - 36) / 2, footerY + 51, { align: "center" });

        // Reset text color
        doc.setTextColor(0, 0, 0);

        doc.setProperties({ title: `Invoice Report` });
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
    };
};